module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui segments"
  }, [_c('div', {
    staticClass: "ui segment"
  }, [_c('div', {
    staticClass: "ui breadcrumb"
  }, [_c('router-link', {
    staticClass: "section",
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("Sākums")]), _vm._v(" "), _c('span', {
    staticClass: "divider"
  }, [_vm._v("/")]), _vm._v(" "), _c('div', {
    staticClass: "active section"
  }, [_vm._v("Lietošanā esošās preces")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "ui segment",
    class: {
      loading: _vm.storeStatus.loading
    }
  }, [_c('table', {
    staticClass: "ui selectable table orange"
  }, [(!_vm.checkClientWidth) ? _c('thead', [_vm._m(0)]) : _vm._e(), _vm._v(" "), (!_vm.checkClientWidth) ? _c('tbody', _vm._l((_vm.items), function(item) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.goods_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.no_of_items) + " gab.")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.bail_per_item) + " €")]), _vm._v(" "), (item.monthly_payment_vat > 0) ? _c('td', [_vm._v(_vm._s(item.monthly_payment_vat) + " €")]) : _c('td', [_vm._v("Nav")]), _vm._v(" "), (item.monthly_payment_vat > 0) ? _c('td', [_vm._v(_vm._s(item.last_executed))]) : _c('td', [_vm._v("-")])])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.checkClientWidth) ? _c('tbody', _vm._l((_vm.items), function(item) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.goods_name))]), _vm._v(" "), _c('td', [_vm._v("Lietošanā: " + _vm._s(item.no_of_items) + " gab.")]), _vm._v(" "), _c('td', [_vm._v("Drošības nauda/pud.: " + _vm._s(item.bail_per_item) + " €")]), _vm._v(" "), (item.monthly_payment_vat > 0) ? _c('td', [_vm._v("Drošības nauda/pud.: " + _vm._s(item.monthly_payment_vat) + " €")]) : _c('td', [_vm._v("Mēneša maksa: Nav")]), _vm._v(" "), (item.monthly_payment_vat > 0) ? _c('td', [_vm._v("Izrakstīts rēķins: " + _vm._s(item.last_executed))]) : _c('td', [_vm._v("Izrakstīts rēķins: -")])])
  }), 0) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("Prece")]), _vm._v(" "), _c('th', [_vm._v("Lietošanā")]), _vm._v(" "), _c('th', [_vm._v("Drošības nauda")]), _vm._v(" "), _c('th', [_vm._v("Mēneša maksa")]), _vm._v(" "), _c('th', [_vm._v("Pēdējo reizi apmaksāts")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-66808bfa!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserRentedGoodsPage.vue
// module id = 352
// module chunks = 1